import(/* webpackMode: "eager" */ "C:\\Users\\Administrator\\Documents\\GitHub\\pione-group-v2\\src\\app\\[lang]\\not-found.tsx");
